import { type UseQueryResult, useQuery } from 'react-query';
import {
  PagedResultDto_ExportTransferAllocateDto,
  TransferAllocateService,
} from '../../services/wealthlane-award-services';

const useGetPendingTransferAllocateSharesForDrs = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: any
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_ExportTransferAllocateDto | undefined,
  unknown
> => {
  const { createdDate, containerStatusId, sorting, skipCount, maxResultCount } = tableInfo;
  const getPendingTransferAllocateSharesForDrs = useQuery(
    ['getPendingTransferAllocateSharesForDrs', createdDate, containerStatusId],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocatePendingTransferAllocatesShareForDrs(
          [],
          [containerStatusId],
          createdDate,
          [],
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return getPendingTransferAllocateSharesForDrs;
};

export default useGetPendingTransferAllocateSharesForDrs;
